module.exports = __webpack_public_path__ + "static/media/proj2_img4.5fe640a0.jpg";